import React from 'react';
import {
  Box,
  Link as MuiLink,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';

import {
  getOriginJobSite,
  getOriginJobSiteName,
  getPublicJobUrl,
} from '../../utils/jobAccountRoutes';

interface IJobPublicationDetailsProps {
  title: string;
  path: string | null | undefined;
  siteId: number | null | undefined;
  isActive: boolean;
  titleSx?: SxProps<Theme>;
}

export const JobPublicationDetails = ({
  title,
  path,
  siteId,
  isActive,
  titleSx,
}: IJobPublicationDetailsProps) => {
  const cpgJobsUrl = isActive ? getPublicJobUrl(siteId, path) : null;
  const originSiteName = getOriginJobSiteName(siteId);
  const originSite = isActive ? getOriginJobSite(siteId, path) : null;

  return (
    <Box>
      {cpgJobsUrl ? (
        <MuiLink
          href={cpgJobsUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={titleSx}
        >
          {title}
        </MuiLink>
      ) : (
        <Typography sx={titleSx}>{title}</Typography>
      )}

      {originSiteName ? (
        <Typography
          component="div"
          sx={{
            color: 'var(--ink-3)',
            fontSize: '0.8rem',
            mt: 0.55,
          }}
        >
          Posted on {originSiteName}
          {originSite ? (
            <>
              {' · '}
              <MuiLink
                href={originSite.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'var(--accent-text)',
                  font: 'inherit',
                  letterSpacing: 'inherit',
                }}
              >
                View on {originSite.name} ↗
              </MuiLink>
            </>
          ) : null}
        </Typography>
      ) : null}
    </Box>
  );
};

export default JobPublicationDetails;
